import useApi, { ApiOptions } from '../base/useApi';
import HospitalHeaderDTO from '@src/adapters/dto/hospital/HospitalHeaderDTO';

interface Params {}

interface Result {
  items: HospitalHeaderDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/hospital/authorised_list/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useAuthorisedHospitalsLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useAuthorisedHospitalsLazy;
